import { ErrorResponse } from '@nuxtjs/apollo'
import { fromPromise } from '@apollo/client/link/utils'
import { FetchResult, Observable } from '@apollo/client/core'
import { refreshAccessToken, clearTokens } from '@utils/apolloTokenUtils'

let isRefreshing = false
let pendingRequests: Array<() => void> = []

const addPendingRequest = (callback: () => void) => {
  pendingRequests.push(callback)
}

const resolvePendingRequests = () => {
  pendingRequests.forEach(callback => callback())
  pendingRequests = []
}

const errorCodes = ['unauthenticated', 'unauthorized']

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.hook('apollo:error', async (error: ErrorResponse) => {
    const { graphQLErrors, networkError, operation, forward } = error
    console.warn('[Apollo error hook]')
    if (graphQLErrors) {
      for (const err of graphQLErrors) {
        const errorCode = err.gqlError.extensions?.code?.toString().toLowerCase()
        if (errorCode && errorCodes.map(e => e.toLowerCase()).includes(errorCode)) {
          if (!isRefreshing) {
            isRefreshing = true
            try {
              const newAccessToken = await refreshAccessToken()
              isRefreshing = false
              resolvePendingRequests()
              operation.setContext(({ headers = {} }) => ({
                headers: {
                  ...headers,
                  authorization: `Bearer ${newAccessToken}`
                }
              }))
              // Recarrega a página após atualizar o token com sucesso
              await clearError()
              window.location.reload()
              return forward(operation) as Observable<FetchResult>
            } catch {
              isRefreshing = false
              pendingRequests = []
              clearTokens()
              await clearError()
              window.location.reload()
            }
          } else {
            return fromPromise(
              new Promise<void>(resolve => {
                addPendingRequest(() => resolve())
              })
            ).flatMap(() => forward(operation) as Observable<FetchResult>)
          }
        } else {
          console.warn(`[Apollo error]: ${err.extensions?.code}`)
        }
      }
    }

    if (networkError) {
      console.warn(`[Network error]: ${networkError}`)
    }
  })
})
